<div *ngIf="showRotateMessage" class="rotate-toast">
  <div>
    <mat-icon class="rotateIcon mobile-icon">screen_rotation</mat-icon>
  </div>
  <p>
    Please rotate your device to landscape mode
  </p>
</div>
<app-header></app-header>
<router-outlet></router-outlet>
<app-loader></app-loader>
<app-alert></app-alert>
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css">

<button class="scroll-top-btn" aria-label="Scroll to top" (click)="scrollToTop()" [class.visible]="showScrollTop">
  <mat-icon>arrow_upward</mat-icon>
</button>